import { render, staticRenderFns } from "./ShoppingListUsers.vue?vue&type=template&id=0d18e61a&"
import script from "./ShoppingListUsers.vue?vue&type=script&lang=js&"
export * from "./ShoppingListUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports